<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div class="faqs answer">
      <b-row class="justify-content-md-center boxes faq-search-container">
        <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
          <FaqSearchBox></FaqSearchBox>
        </b-col>
      </b-row>
      <div v-if="relatedFaqs.length" class="faq-questions look-for-your-question">
        <StepTitle hr>Look for your question below</StepTitle>
        <b-row class="justify-content-md-center">
          <b-col class="faq-question-cards">
            <div class="faq-container-first">
              <b-row class="questions justify-content-md-center position-relative zIndex" >
                <b-col v-for="faq in relatedFaqs" :key="'faq-' + faq.id" md='4' class="related-q-p">
                  <router-link class="faq-link" :to="{ name: 'faq-details', params: { slug: faq.slug }}" custom>
                    <b-card :title="faq.question" sub-title="" class="my-faq-card-two rel-faq-card h-100">
                      <b-card-text v-html="getShortAnswer(faq)" class="footer-card-answer">
                      </b-card-text>
                      <font-awesome-icon :icon="['far', 'thumbs-up']" class="faq-qtn-icon" @click="vote(faq, true)"></font-awesome-icon>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <section class="boxes update-back-btn">
          <b-row class="justify-content-md-center">
            <b-col md="6">
              <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
            </b-col>
          </b-row>
        </section>
      </div>
      <div v-else>
        <StepTitle hr>No questions found</StepTitle>
        <b-row class="justify-content-md-center boxes">
          <b-col md="8" lg="6">
            <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success input-btn">Back</button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Breadcrumbs from '@/components/Breadcrumbs'
import FaqSearchBox from '@/components/FaqSearchBox'
import {stopMouseflowRecording} from '@/utils'
const StepTitle = () => import('./StepTitle')

export default {
  name: 'Faqs',
  components: {
    Breadcrumbs,
    StepTitle,
    FaqSearchBox
  },
  computed: {
    ...mapState(['session', 'selectedFaqTopic', 'faqsLoading', 'votedFaqs', 'isIE', 'relatedFaqs'])
  },
  methods: {
    getShortAnswer: function(faq) {
      if (faq.blurb && faq.blurb.length) {
        return faq.blurb
      }

      let div = document.createElement('div')
      div.innerHTML = faq.answer

      return div.innerText
    },
    vote: function(faq, thumbsUp) {
      const path = thumbsUp ? 'upvote' : 'downvote'

      if (!(faq.id in this.votedFaqs)) {
        // faq not yet voted, so vote for it
        this.$store.commit('busy')
        this.$store.dispatch('set_session_started')
        axios.post('/faq/' + faq.id.toString() + '/' + path + '/', {})
          .then(resp => {
            this.$store.commit('set_faq_vote', faq)
            this.$store.commit('ready')
          })
          .catch(err => {
            console.log(err)
            this.$store.commit('ready')
          })
      }
    },
    goBack: function() {
      this.$router.replace({name: 'faq-topics'})
    },
    initFaqs: function(delay = 0) {
      if (!this.selectedFaqTopic) {
        this.goBack()
        return
      }
      this.$store.commit('busy')
      this.$store.dispatch('fetch_topic_faqs', this.selectedFaqTopic)
    }
  },
  created() {
    this.$store.commit('busy')
    this.$store.commit('update_faq_search_results', [])
    this.initFaqs()
    stopMouseflowRecording()
  }
}
</script>
<style scoped>

</style>
